const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "32px",
    width: "32px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77757F"
    },
    d: "M372.364,116.364H139.636C62.641,116.364,0,179.005,0,256s62.641,139.636,139.636,139.636h232.727 C449.359,395.636,512,332.995,512,256S449.359,116.364,372.364,116.364z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 139.636,
    cy: 256,
    r: 116.364
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9A8AE"
    },
    d: "M139.636,395.636C62.641,395.636,0,332.995,0,256s62.641-139.636,139.636-139.636 S279.273,179.005,279.273,256S216.632,395.636,139.636,395.636z M139.636,162.909c-51.33,0-93.091,41.761-93.091,93.091 s41.761,93.091,93.091,93.091S232.727,307.33,232.727,256S190.967,162.909,139.636,162.909z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOff);
export default __webpack_public_path__ + "static/media/switch-off.a580fa3b.svg";
export { ForwardRef as ReactComponent };